import { Pipe, PipeTransform } from '@angular/core';
import { FormControl, NgControl } from '@angular/forms';
import { IsEmptyObject } from 'projects/components/util/is-empty-object';

@Pipe({
  name: 'hasControlError',
  standalone: true,
})
export class HasControlErrorPipe implements PipeTransform {
  transform(ngControls?: NgControl[] | FormControl[], errorCode?: string): unknown {
    if (!ngControls) {
      return false;
    }

    if (!errorCode) {
      // Check if it has any errors
      const errors = ngControls.find((control) => control.errors);
      return !!errors && !IsEmptyObject(errors);
    }

    return !!ngControls.find((control) => control.hasError(errorCode) && control.errors && !IsEmptyObject(control.errors));
  }
}
